import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import {action, computed, observable} from 'mobx';
import {observer} from 'mobx-react';
import 'react-quill/dist/quill.snow.css';
import FaPlay from 'react-icons/lib/fa/play';
import FaStop from 'react-icons/lib/fa/stop';
import BaseButton from '../../../components/button/BaseButton';

@injectIntl
@observer
class LessonInfoPreview extends Component {
    @observable maxHeight = this.initialHeight;
    @observable isOpen = false;
    initialHeight = 240;

    @action setMaxHeight = (val) => {
        this.maxHeight = val;
    };

    @action toggleIsOpen = () => {
        this.isOpen = !this.isOpen;
    };

    @computed get isExpandable() {
        return this.props.readMore && (this.initialHeight < this.maxHeight) && !this.isOpen;
    }

    componentDidUpdate(prevProps) {
        if (this.props.readMore && prevProps.description !== this.props.description) {
            this.setMaxHeight(this.calculateHeight());
        }
    }

    setRef = (node) => {
        this.container = node;
    };

    calculateHeight() {
        return this.container && this.container.offsetHeight;
    }

    render() {
        const {description, projectName, togglePlay, isPlaying,
            showPlay, readMore, intl: {formatMessage: translate}} = this.props;
        const maxHeight = this.isOpen ? this.maxHeight : this.initialHeight;

        if (description) {
            return (
                <div className="lesson-student">
                    {showPlay && <Fragment>
                        <div className="lesson-label"><FormattedMessage id="createLesson.audio"/></div>
                        <div className="project-play-wrap">
                            <div className="toggle-audio-btn" onClick={togglePlay}>
                                {isPlaying ? <FaStop/> : <FaPlay style={{left: 1}}/>}
                            </div>
                            <div className="project-play-title">{projectName}</div>
                        </div>
                    </Fragment>}
                    <div
                        className={`${this.isExpandable ? 'collapsed' : ''} lesson-student-preview`}
                        style={readMore ? {maxHeight} : null}>
                        <div className="lesson-label"><FormattedMessage id="createLesson.taskDescription"/></div>
                        <div className="ql-editor" ref={this.setRef} dangerouslySetInnerHTML={{__html: description}}/>
                        {this.isExpandable &&
                            <BaseButton onClick={this.toggleIsOpen} className="read-more" label={translate({id: 'general.readMore'})}/>
                        }
                    </div>
                </div>
            );
        }
        return null;
    }
}

LessonInfoPreview.propTypes = {
    projectName: PropTypes.string,
    description: PropTypes.string,
    showPlay: PropTypes.bool,
    togglePlay: PropTypes.func,
    isPlaying: PropTypes.bool,
    readMore: PropTypes.bool
};

export default LessonInfoPreview;
